/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

export const burgerButtonStyle = {
  burgerButton: {
    position: "relative"
  },
  needsAttention: {
    position: "absolute",
    top: 0,
    right: "-5%"
  }
};
